import BaseInput from 'src/components/Inputs/BaseInput.vue';
import Card from 'src/components/Cards/Card.vue';
import SvgIcon from 'src/components/SvgIcon.vue';

const GlobalComponents = {
  install(Vue) {
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(Card.name, Card);
    Vue.component(SvgIcon.name, SvgIcon);
  },
};

export default GlobalComponents;
